import { Footer } from '@purpur/library';
import styled, { css } from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

import { ONETRUST_COOKIE_SETTING_BUTTON_CLASSNAME } from './constants';

// TODO: remove temp hack once fixed in PurPur or CMS returns more useful address data

export const StyledFooter = styled(Footer)<{ $contactSectionAriaLabel: string }>`
    // TODO: remove temp hack once fixed in PurPur or CMS returns more useful address data

    ${({ $contactSectionAriaLabel }) => css`
        section[aria-label='${$contactSectionAriaLabel}'] {
            padding-top: ${getPurpurSpacing('100')};
        }
    `}
    [class*='_purpur-footer__additional'] [class*='${ONETRUST_COOKIE_SETTING_BUTTON_CLASSNAME}'] {
        padding: ${getPurpurSpacing('100')} 0;
    }
`;
